import { useTranslation } from "react-i18next"

export default function Footer() {

    const { t } = useTranslation();
    
    return(
        <footer className="footer-class" >
          <span className="text-white">
           © 2026 Sterz <span className="text-secondary">{t("text.protected")}</span> 
          </span>
        </footer>
    )
}